<script lang="ts">
  /**
   * The select, AppInput's sibling: same border, radius and focus treatment, sized a touch tighter
   * since the native caret already claims some of an input's usual right-hand padding.
   */
  import type { Snippet } from "svelte";

  // $bindable for the same reason as AppInput: most call sites pass value + onchange one-way, but
  // PublishDialog's form fields use bind:value the ordinary Svelte way.
  let {
    value = $bindable(""),
    size = "md",
    disabled = false,
    onchange,
    children,
    ...rest
  }: {
    value?: string;
    size?: "lg" | "md" | "sm" | "xs";
    disabled?: boolean;
    onchange?: (event: Event & { currentTarget: HTMLSelectElement }) => void;
    children?: Snippet;
    [key: string]: unknown;
  } = $props();

  const SIZES = {
    lg: "h-[var(--brand-control-h-lg)] pl-4 pr-3 text-base",
    md: "h-[var(--brand-control-h-md)] pl-3.5 pr-2.5 text-sm",
    sm: "h-[var(--brand-control-h-sm)] pl-3 pr-2 text-sm",
    xs: "h-[var(--brand-control-h-xs)] pl-2.5 pr-1.5 text-xs",
  } as const;
</script>

<select
  bind:value
  {disabled}
  {onchange}
  {...rest}
  class="rounded-control border border-line bg-white text-ink
         transition-colors duration-200 ease-out
         hover:border-ink-muted focus:border-accent focus:outline-none
         disabled:opacity-50 disabled:cursor-not-allowed
         {SIZES[size]}"
>
  {@render children?.()}
</select>
